<template>
 <div :class="windowClass">
   <v-container>
    <v-row>
      <v-col cols="12">
                <v-card>
               <v-toolbar>
                 <v-icon left color="primary">mdi-wallet</v-icon> Top Ups
                 <v-spacer/>
                 <span style="width: 290px;">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            dense
                            outlined
                            hide-details
                        ></v-text-field>
                 </span>
                 <v-divider vertical inset class="ml-5 mr-2"/>
                        <v-btn text small color="success" v-if="ALLOW('wallet_request_top_up')"  @click="selecteditem={}, state='new', form=true"><v-icon small left color="success">mdi-plus</v-icon>  Request</v-btn>
               </v-toolbar>
               <v-card-text>
                <v-data-table
                    class="va-table"
                    dense
                    :headers="headers"
                    :search="search"
                    :items="items"
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index" :class="'text-'+item.status.toLowerCase()">
                            <td >
                            <v-icon v-if="item.status != 'Cancelled'" small left color="warning" @click="selectedID=item.id, state='update', form=true" >mdi-open-in-new</v-icon>
                            {{ item.franchisee }}</td>
                            <td>{{ item.requested_by }}</td>
                            <td>{{ $moment(item.req_dt).format("MMM, DD YYYY hh:mm A") }}</td>
                             <td :class="STATUS_COLOR(item.status)">{{ item.status }}</td>
                              <td class="text-right">{{ $money(item.amount) }}</td>
                        </tr>
                        </tbody>
                    </template>
                    </v-data-table>
               </v-card-text>
             </v-card>
          </v-col>
         
    </v-row>
    </v-container>
     <va-wallet-form :show="form" :selectedID="selectedID"  :state="state" @DialogEvent="formEvent" />
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        search:"",
        selectedID:  null,
        trans_dailog: false,
        areaform: false,
        state: 'new',
        items:[],
        headers: [
            { text: 'Franchise', value:"franchisee"},
            { text: 'Requested By', value:"requested_by"},
            { text: 'Requested', value:"req_dt"},
            { text: 'Status', value:"status"},
            { text: 'Amount', value: "amount", align: "right" }
        ]
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getItems()
         // this.GET_FRANCHISEE()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
    
      formEvent(){
          this.form = false
          this.getItems()
      },

      getItems: function() { 
        this.$http.get("wallet/list").then(response => {
            response.data.list != null?this.items = response.data.list:this.items =[]
        }).catch(e => {
        console.log(e.data)
        })
     }
    }
  }
</script>